import React from 'react';
import { Typography } from '@mui/material';
import { groupBy } from 'lodash';

import {
  OnboardingStep,
  onboardingStepBarSections,
  onboardingStepBarTitles,
} from '../../../data-access';

import './OnboardingStepBar.scss';
import clsx from 'clsx';

interface OnboardingStepBarProps {
  steps: OnboardingStep[];
  currentStep: OnboardingStep;
  className?: string;
}

export const OnboardingStepBar: React.FC<OnboardingStepBarProps> = ({
  steps,
  currentStep,
  className,
}) => {
  if (!currentStep.stepBarKey) {
    return null;
  }

  const title = onboardingStepBarTitles[currentStep.stepBarKey];
  const stepsByKeys = groupBy(steps, 'stepBarKey');

  return (
    <div className={clsx('onboarding-step-bar', className)}>
      <div className="onboarding-step-bar__container">
        {onboardingStepBarSections.map((stepKey) => {
          const stepsInCurrentSection = stepsByKeys[stepKey] || [];
          const currentStepInSection = stepsInCurrentSection.findIndex(
            (step) => step.key === currentStep.key
          );

          // If we're past this section, fill it completely
          const isPastSection =
            onboardingStepBarSections.findIndex((step) => step === currentStep.stepBarKey) >
            onboardingStepBarSections.findIndex((step) => step === stepKey);

          // If we're in this section, fill it partially based on progress
          const isCurrentSection = currentStep.stepBarKey === stepKey;

          const progress = isPastSection
            ? 1
            : isCurrentSection
              ? (currentStepInSection + 1) / stepsInCurrentSection.length
              : 0;

          return (
            <div key={stepKey} className="onboarding-step-bar__step-container">
              <div className="onboarding-step-bar__progress-container">
                <div
                  className="onboarding-step-bar__progress-fill"
                  style={{ width: `${progress * 100}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
